module.exports = __webpack_public_path__ + "img/part3-2.64b10b61.png";